module.exports = __webpack_public_path__ + "assets/img/2191591934007_.pic_hd.48ff4138.jpg";